import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {routes} from './routes';
import CodeGate from './components/CodeGate';
import RSVPPage from './pages/RSVPPage';
import MainPage from './pages/MainPage';
import DressCodePage from "./pages/DressCodePage";
import GiftRegistryPage from "./pages/GiftRegistryPage";
import AlcoholPage from "./pages/AlcoholPage";
import FaqPage from "./pages/FaqPage";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFoundPage from "./pages/NotFoundPage";
import ProtectedLayout from "./components/ProtectedLayout";
import {ScrollToTop} from "./components/ScrollToTop";
import RootRedirector from "./components/RootRedirector";

const protectedRoutes = [
    { path: routes.Home, element: <MainPage /> },
    { path: routes.RSVP, element: <RSVPPage /> },
    { path: routes.DressCode, element: <DressCodePage /> },
    { path: routes.GiftRegistry, element: <GiftRegistryPage /> },
    { path: routes.Alcohol, element: <AlcoholPage key="alcohol-page" /> },
    { path: routes.FAQ, element: <FaqPage /> },
];

function App() {
    return (
        <>
            <ScrollToTop/>
            <Routes>
                {/* Public routes & Root Handling */}
                <Route path="/" element={<RootRedirector />} />
                <Route path="/code-gate" element={<CodeGate/>}/>

                {/* Protected routes */}
                <Route element={<ProtectedRoute/>}>
                    <Route element={<ProtectedLayout/>}>
                        {protectedRoutes.map((route) => (
                            <Route key={route.path} path={route.path} element={route.element} />
                        ))}
                    </Route>
                </Route>

                {/* Not Found Route */}
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </>
    );
}

export default App;
